import { FeatureAppMemoryStoreV1 } from "@volkswagen-onehub/feature-app-memory-store";
import { BaseBffResponse } from "@volkswagen-onehub/vw-starter-types-support";
import { UniversalState } from "./universal-state";
/**
 * The bff response is stored in the memory store.
 * The reason is that bff state must be saved between rendering on the server.
 * The feature app expects the bff response to be in the memory store when it renders.
 * 
 * @param memoryStore
 * @param bffResponse
 */
export const saveBffResponse = <T extends BaseBffResponse>(
  memoryStore: FeatureAppMemoryStoreV1<UniversalState<T>>,
  bffResponse: T
) => {
  memoryStore.setState({
    payload: bffResponse,
    status: "loaded",
  });
};
